import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUserFromCallback } = useAuth();
  const processed = useRef(false);

  const exchange = useCallback(async (sessionId) => {
    try {
      const { data } = await api.post('/auth/google/session', { session_id: sessionId });
      setUserFromCallback(data.user);
      window.history.replaceState({}, '', '/dashboard');
      navigate('/dashboard', { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Google sign-in failed');
      navigate('/login', { replace: true });
    }
  }, [navigate, setUserFromCallback]);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) {
      navigate('/login');
      return;
    }
    exchange(sessionId);
  }, [navigate, exchange]);

  return (
    <div className="h-screen flex items-center justify-center" data-testid="auth-callback">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      <span className="ml-3 text-sm text-muted-foreground">Completing sign-in…</span>
    </div>
  );
}
